import { render, staticRenderFns } from "./my-info.vue?vue&type=template&id=87c320c8&scoped=true&"
import script from "./my-info.vue?vue&type=script&lang=js&"
export * from "./my-info.vue?vue&type=script&lang=js&"
import style0 from "./my-info.vue?vue&type=style&index=0&id=87c320c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c320c8",
  null
  
)

export default component.exports